import React, { useEffect, useState } from "react";
import { superAdmin } from "../../api";
import { PageHeader, Btn, FormField, inputStyle, LoadingSpinner } from "../../components/ui";
import toast from "react-hot-toast";

export default function BrandingSettingsPage() {
  const [config,  setConfig]  = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [dirty,   setDirty]   = useState(false);

  useEffect(() => {
    superAdmin.getVendorBranding()
      .then(r => setConfig(r.data))
      .catch(() => toast.error("Failed to load branding config."))
      .finally(() => setLoading(false));
  }, []);

  const set = (k, v) => { setConfig(p => ({ ...p, [k]: v })); setDirty(true); };

  const handleSave = async () => {
    setSaving(true);
    try {
      await superAdmin.updateVendorBranding(config);
      toast.success("Branding config saved.");
      setDirty(false);
    } catch { toast.error("Failed to save."); }
    finally { setSaving(false); }
  };

  if (loading) return <div style={{ padding:"32px" }}><LoadingSpinner /></div>;
  if (!config)  return <div style={{ padding:"32px", color:"#EF4444" }}>Failed to load branding config.</div>;

  return (
    <div style={styles.root}>
      <PageHeader
        title="Vendor Branding"
        subtitle="Configure EliyaQ branding shown on facility display boards."
        action={<Btn onClick={handleSave} disabled={saving || !dirty}>{saving ? "Saving…" : dirty ? "Save Changes" : "Saved ✓"}</Btn>}
      />

      <div style={styles.card}>
        <div style={styles.cardTitle}>Slide-in Notification Content</div>
        <div style={styles.cardBody}>
          <FormField label="Tagline" hint="Short description shown on the slide">
            <input style={inputStyle} value={config.tagline || ""} onChange={e => set("tagline", e.target.value)} placeholder="Queue Management, Simplified" />
          </FormField>
          <FormField label="Website">
            <input style={inputStyle} value={config.website || ""} onChange={e => set("website", e.target.value)} placeholder="yourcompany.com" />
          </FormField>
          <FormField label="Phone">
            <input style={inputStyle} value={config.phone || ""} onChange={e => set("phone", e.target.value)} placeholder="+233 XX XXX XXXX" />
          </FormField>
          <FormField label="Email">
            <input style={inputStyle} type="email" value={config.email || ""} onChange={e => set("email", e.target.value)} placeholder="hello@yourcompany.com" />
          </FormField>
          <FormField label="WhatsApp">
            <input style={inputStyle} value={config.whatsapp || ""} onChange={e => set("whatsapp", e.target.value)} placeholder="+233 XX XXX XXXX" />
          </FormField>
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.cardTitle}>Timing</div>
        <div style={styles.cardBody}>
          <FormField label="Slide Interval (minutes)" hint="How often the slide-in appears">
            <input style={inputStyle} type="number" value={config.slide_interval_minutes || 5} onChange={e => set("slide_interval_minutes", parseInt(e.target.value))} min={1} max={60} />
          </FormField>
          <FormField label="Slide Duration (seconds)" hint="How long the slide-in stays visible">
            <input style={inputStyle} type="number" value={config.slide_duration_seconds || 8} onChange={e => set("slide_duration_seconds", parseInt(e.target.value))} min={3} max={30} />
          </FormField>
        </div>
      </div>

      <div style={styles.note}>
        <span style={{ fontSize:"13px", color:"var(--text-secondary)" }}>
          ℹ️ Per-facility branding visibility is controlled from the Facilities page. This page configures what content appears when branding is enabled.
        </span>
      </div>
    </div>
  );
}

const styles = {
  root:      { padding:"32px", fontFamily:"'DM Sans','Segoe UI',sans-serif", maxWidth:"640px" },
  card:      { background:"var(--surface-bg)", border:"1px solid var(--surface-border)", borderRadius:"12px", overflow:"hidden", marginBottom:"16px" },
  cardTitle: { padding:"12px 18px", fontSize:"11px", fontWeight:"700", color:"#2563EB", letterSpacing:"0.08em", textTransform:"uppercase", borderBottom:"1px solid var(--surface-border)", background:"rgba(37,99,235,0.05)" },
  cardBody:  { padding:"16px 18px", display:"flex", flexDirection:"column", gap:"14px" },
  note:      { padding:"14px 18px", background:"var(--input-bg)", borderRadius:"10px", border:"1px solid var(--surface-border)" },
};
